// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kN1Ak","buttons":"styles_buttons__2IcSg"};